import Vue from 'vue'
import VueRouter from 'vue-router'
import BlankLayout from '../layouts/BlankLayout'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: BlankLayout,
        redirect: '/',
        children: [
            // {
            //     path: 'login',
            //     name: 'login',
            //     hideInMenu: true,
            //     component: () => import('@/views/login/index')
            // },
            {
                path: '/',
                name: 'index',
                hideInMenu: true,
                component: () => import('@/views/mall/Index')
            },
            {
                path: 'shopDetail',
                name: 'shop-detail',
                hideInMenu: true,
                component: () => import('@/views/mall/CompanyList')
            },
            {
                path: 'goodsDetail',
                name: 'goods-detail',
                hideInMenu: true,
                component: () => import('@/views/mall/modules/GoodsDetail')
            },
            {
                path: 'cart',
                name: 'cart',
                hideInMenu: true,
                component: () => import('@/views/mall/modules/Cart')
            },
            {
                path: 'checkout-order',
                name: 'checkout-order',
                hideInMenu: true,
                component: () => import('@/views/mall/modules/CheckoutOrder')
            },
            {
                path: 'complete-order',
                name: 'complete-order',
                hideInMenu: true,
                component: () => import('@/views/mall/modules/CompleteOrder')
            },
            {
                path: 'account',
                name: 'account',
                hideInMenu: true,
                component: () => import('@/views/account/Index')
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
